module.exports = __webpack_public_path__ + "img/sunset.da08d504.jpg";